
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.333 11.914l7.51-7.51a1.5 1.5 0 011.175-.434l5.253.404a1.5 1.5 0 011.38 1.38l.404 5.253a1.5 1.5 0 01-.434 1.176l-7.51 7.51a1.5 1.5 0 01-2.121 0l-5.657-5.658a1.5 1.5 0 010-2.12zm17.218-1.022a3 3 0 01-.87 2.351l-7.51 7.51a3 3 0 01-4.242 0l-5.657-5.657a3 3 0 010-4.242l7.51-7.51a3 3 0 012.351-.87l5.253.404a3 3 0 012.761 2.761l.404 5.253z"}}),_c('path',{attrs:{"d":"M14.586 7.318a1.5 1.5 0 102.121 2.121 1.5 1.5 0 00-2.121-2.121z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.691 13.505l2.829 2.829a.75.75 0 001.06-1.061l-2.828-2.829a.75.75 0 10-1.06 1.061z"}})])
          )
        }
      }
    